// @flow
import React from 'react';
import {
  compose,
  withProps,
  setDisplayName,
} from 'recompose';
import reactCSS from 'reactcss';
import SearchForm, {
  Design as SearchFormDesign,
} from './Form';
import { getStyles } from '@ux/style-utils';
import { gu2px } from '@ux/theme-utils';
// $FlowFixMe

export const stylesheet = ({
  theme,
}) => {
  return {
    default: {
      root: {
        display: 'flex',
        flexDirection: 'column',
        marginBottom: gu2px(2, theme.spacing),
      },
      buttonText: {
        display: 'flex',
        alignItems: 'center',
        height: '100%',
        justifyContent: 'center',
      },
    },
    isMinSm: {
      root: {
        flexDirection: 'row',
      },
    },
  };
};

// eslint-disable-next-line no-shadow
export const stylesheetToStyles = (stylesheet, props) => reactCSS(stylesheet, {
  isMinSm: props.isMinSm,
}, props);


export const PureStaticSearch = ({
  theme,
  styles,
  isMinSm,
  isMinMd,
  initialValues,
  // Events
  onSubmit,
  onChange,
}) => (
  <div style={styles.root}>
    <SearchForm
      theme={theme}
      isMinSm={isMinSm}
      isMinMd={isMinMd}
      onSubmit={onSubmit}
      onChange={onChange}
      design={SearchFormDesign.STATIC}
      initialValues={initialValues}
    />
  </div>
);

export const enhance = compose(
  setDisplayName('StaticSearch'),
  withProps((ownerProps) => ({
    styles: getStyles(stylesheet, stylesheetToStyles, ownerProps),
  })),
);

export default enhance(PureStaticSearch);
